import { getCartErrorMessage } from '@theme/cart-feedback';

// Cart drawer upsell: adds one more line (the other color) on top of the existing cart, never replacing a line.
// Uses the same Standard Actions cart mutation as <s-product-form> and <s-cart>, so the added line shares cart
// state with the drawer's quantity/remove controls. The shared updateCart override refreshes the mounted
// <s-cart> partials, keeping the drawer, totals and header count in sync.
class SCartUpsell extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('submit', (event) => this.#onSubmit(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  async #onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // Without Standard Actions, leave the native product form submit in place.
    if (!window.Shopify?.actions?.updateCart) return;
    const variantId = String(new FormData(form).get('id') || '').trim();
    if (!variantId) return;

    event.preventDefault();
    if (this.getAttribute('aria-busy') === 'true') return;

    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-add-to-cart-error]');
    this.setAttribute('aria-busy', 'true');
    button?.setAttribute('aria-disabled', 'true');
    if (error) { error.hidden = true; error.textContent = ''; }

    try {
      const result = await window.Shopify.actions.updateCart(
        { lines: [{ merchandiseId: variantId, quantity: 1 }] },
        { event: { context: 'cart' }, signal: this.#ac?.signal }
      );
      const userError = result?.userErrors?.[0]?.message;
      if (userError) throw new Error(userError);
    } catch (err) {
      if (this.#ac?.signal.aborted) return;
      if (error) {
        error.textContent = getCartErrorMessage(err) || err?.message || this.dataset.errorMessage || '';
        error.hidden = false;
      }
    } finally {
      if (this.isConnected) {
        this.removeAttribute('aria-busy');
        button?.removeAttribute('aria-disabled');
      }
    }
  }
}

if (!customElements.get('s-cart-upsell')) customElements.define('s-cart-upsell', SCartUpsell);
